<template lang="pug">
  VContainer.coming-soon__container
    .coming-soon__title(
      tabindex="0"
    )
      template(v-if="hasPreSaleEnded")
        .coming-soon__logo(v-if="isMobile")
            IOLogo
        span.t--yellow Public Sale
        span Starting Soon
      template(v-else)
        span.t--yellow(v-if="!isMobile") Imaginary Ones
        .coming-soon__logo(v-else)
          IOLogo
        span Coming Soon

    template(v-if="!hasPreSaleEnded")
      .mint-details__container
        div.line
          span.t--bold Private Whitelist Sale:&nbsp;
          br(v-if="isMobile")
          span {{ preSaleLocalTime }}
        div.line
          span.t--bold Public Dutch Auction Sale:&nbsp;
          br(v-if="isMobile")
          span {{ publicSaleLocalTime }}
        VBtn.v-btn--mint-details(
              x-large
              rounded
              dark
              :elevation="0"
              :href="mintDetailsURL"
            ) Read Mint Details
</template>

<script>
import saleMixin from '@/mixins/sale-mixins';

export default {
  name: 'MintComingSoon',
  components: {
    IOLogo: () => import('@/components/IOLogo'),
  },
  mixins: [saleMixin],
  props: {
    isMobile: { type: Boolean, default: false },
  },
  computed: {
    mintDetailsURL() {
      return `${process.env.VUE_APP_LANDING_URL}mint-details`;
    },
  },
};
</script>

<style lang="scss">
.coming-soon__title {
  font-family: $font-primary;
  color: $white;
  font-size: 3rem;
  font-weight: 900;
  line-height: 1;
  text-transform: uppercase;

  @include small-mobile {
    font-size: 2.125rem;
  }

  @include mobile {
    margin-bottom: 50px;
  }

  @include tablet {
    font-size: 4rem;
  }

  @include desktop {
    font-size: 4.5rem;
  }

  @include wide-desktop {
    font-size: 7rem;
  }

  @include big {
    font-size: 9.5rem;
  }

  span {
    display: block;
    position: relative;
  }
}

.mint-details__container {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .line {
    @include mobile {
      margin-bottom: 20px;
    }
  }

  > div > span {
    font-family: $font-primary;
    font-size: 1.063rem;
    text-transform: uppercase;
    margin-bottom: 10px;

    @include mobile {
      font-size: 1rem;
    }

    @include hd {
      font-size: 1.375rem;
    }

    @include big {
      font-size: 2rem;
    }
  }
}

.v-btn--mint-details {
  margin-top: 20px;
  margin-right: auto;

  @include mobile {
    margin-left: auto;
  }
}

.is-vertical {
  .coming-soon__title {
    color: $yellow;

    span {
      font-size: 1.75rem;
    }
  }
}
</style>
